import ReactDOM from "react-dom";

export default function Portal(props) {
  const { parent, children } = props;
  return ReactDOM.createPortal(children, parent || document.body);
}
